import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { User } from 'lucide-react';

const Team = () => {
  const { t } = useLanguage();

  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t.team.title}
          </h2>
          <p className="text-xl text-gray-600">{t.team.subtitle}</p>
        </div>

        {/* Team Grid - Centered for 3 members */}
         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.team.members.map((member, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-2 hover:border-teal-500 text-center"
            >
              <CardHeader>
                {/* Avatar Placeholder */}
                <div className="mx-auto mb-4">
                  <div className="w-32 h-32 rounded-full bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                    <User className="w-16 h-16 text-white" />
                  </div>
                </div>
                <CardTitle className="text-xl mb-1 group-hover:text-teal-600 transition-colors">
                  {member.name}
                </CardTitle>
                <CardDescription className="text-base font-semibold text-teal-600">
                  {member.position}
                </CardDescription>
              </CardHeader>

              <CardContent className="space-y-4">
                <p className="text-gray-600 text-sm">{member.bio}</p>
                <div className="flex flex-wrap gap-2 justify-center">
                  {member.expertise.map((skill, i) => (
                    <Badge key={i} variant="secondary" className="text-xs">
                      {skill}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;